export const validation = {
  titleMaxChar: 50,
  slides: {
    min: 3,
    max: 12
  }
}